import { useCallback, useMemo } from "react";
import useSWR from "swr";
import { URL_API } from "@richbeauty/services/endpoint";
import { S3Type } from "shared/constants/AppEnums";
import { convertToS3Link } from "@richbeauty/utility/Utils";
import jwtAxios from "../../../@richbeauty/services/auth/jwt-auth/jwt-api";

const getSettings = async (params) => {
  return await jwtAxios.get(URL_API.CMS_SETTINGS.GET_SETTINGS, {
    params,
  });
};
export const SettingType = {
  WEB: "web",
  APP: "app",
};

const useGetSetting = () => {
  const getData = useCallback(() => getSettings(), []);

  const { data, isLoading, mutate } = useSWR(
    { url: URL_API.CMS_SETTINGS.GET_SETTINGS },
    getData
  );
  const res = useMemo(() => {
    const dataSetting = data?.map(({ value, id, type }) => {
      const { rich, mac } = JSON.parse(value) ?? {};

      const { favicon: richFavicon, logo: richLogo, ...restRich } = rich ?? {};
      const { favicon: macFavicon, logo: macLogo, ...restMac } = mac ?? {};

      return {
        type,
        rich: {
          ...restRich,
          favicon: richFavicon
            ? {
              uid: richFavicon,
              name: richFavicon,
              url: convertToS3Link(S3Type.WSID_FAVICON, id, richFavicon),
            }
            : null,
          logo: richLogo
            ? {
              uid: richLogo,
              name: richLogo,
              url: convertToS3Link(S3Type.WSID_LOGO, id, richLogo),
            }
            : null,
        },
        mac: {
          ...restMac,
          favicon: macFavicon
            ? {
              uid: macFavicon,
              name: macFavicon,
              url: convertToS3Link(S3Type.WSID_FAVICON_MAC, id, macFavicon),
            }
            : null,
          logo: macLogo
            ? {
              uid: macLogo,
              name: macLogo,
              url: convertToS3Link(S3Type.WSID_LOGO_MAC, id, macLogo),
            }
            : null,
        },
      };
    });
    return {
      dataSetting,
    };
  }, [data]);
  return {
    dataInfoSetting: res?.dataSetting?.find(
      (item) => item.type === SettingType.WEB
    ),
    isLoadingInfoSetting: isLoading,
    mutateInfoSetting: mutate,
  };
};
export default useGetSetting;
